export default __webpack_public_path__ + "css/user.bundle.css";